// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"D_thecomp__beZLd","loop":"D_loop__I8deB"};